import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import type { MarketActionsV2Action, MarketActionsV2EntryPoint, MarketLendWithdrawSource } from '../events';
import { trackMarketActionsV2EntryViewed } from '../trackers/market-actions-v2';

/**
 * Fires one `market_actions_v2_entry_viewed` impression when a market-actions-v2
 * entry point (the supply/borrow or repay/withdraw Simple Action Panel tab, or a
 * Position Manager borrow/repay dialog) mounts. `entryPoint` + `action`
 * distinguish the surface so impressions compare per surface and against clicks +
 * conversion.
 *
 * An Effect is the right tool: an impression has no user event to hang it on —
 * the only signal is the component being committed — and firing in render would
 * break purity (these components run under the React Compiler). The ref
 * keeps it to one fire per mount, including dev StrictMode's double-invoke. Pass
 * `enabled: false` to defer the impression until the entry point is actually
 * reachable (e.g. behind the `marketSupplyBorrow` / `marketRepayWithdraw` flags).
 */
export const useTrackMarketActionsV2EntryViewed = t0 => {
  const $ = _c(9);
  const {
    entryPoint,
    action,
    marketId,
    chainId,
    chainName,
    source,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const tracked = useRef(false);
  let t2;
  let t3;
  if ($[0] !== action || $[1] !== chainId || $[2] !== chainName || $[3] !== enabled || $[4] !== entryPoint || $[5] !== marketId || $[6] !== source) {
    t2 = () => {
      if (!enabled || tracked.current) {
        return;
      }
      tracked.current = true;
      trackMarketActionsV2EntryViewed({
        entryPoint,
        action,
        marketId,
        chainId,
        chainName,
        source
      });
    };
    t3 = [enabled, entryPoint, action, marketId, chainId, chainName, source];
    $[0] = action;
    $[1] = chainId;
    $[2] = chainName;
    $[3] = enabled;
    $[4] = entryPoint;
    $[5] = marketId;
    $[6] = source;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
};